import { render, staticRenderFns } from "./ShippingAddressManagement.vue?vue&type=template&id=2ffc224e&scoped=true&"
import script from "./ShippingAddressManagement.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc224e",
  null
  
)

export default component.exports